export default __webpack_public_path__ + "static/media/Brownfield.7ae0ed6b.svg";